function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var BankOverlayTemplate = require('./bank.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var BankOverlay = /*#__PURE__*/function () {
  function BankOverlay(app, mod) {
    _classCallCheck(this, BankOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, false);
    this.selected_resource = null;
    this.my_resources = {};
    this.minForTrade = null;
  }
  return _createClass(BankOverlay, [{
    key: "render",
    value: function render() {
      var _this = this;
      this.my_resources = {};
      this.minForTrade = this.mod.analyzePorts(); //4;  //1) Fix to have 3:1 port, 2) Fix for resource specific 2:1 ports

      console.log("****************");
      console.log(this.minForTrade);
      var _iterator = _createForOfIteratorHelper(this.mod.returnResources()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var resource = _step.value;
          var temp = this.mod.countResource(this.mod.game.player, resource);
          if (temp >= this.minForTrade[resource]) this.my_resources[resource] = temp;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.overlay.show(BankOverlayTemplate(this.app, this.mod, this), function () {
        _this.selected_resource = null;
      });
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var this_bank = this;
      if (this_bank.selected_resource) {
        document.querySelectorAll('.settlers-desired-resources img').forEach(function (row) {
          row.onclick = function (e) {
            var desired_resource = e.currentTarget.getAttribute('id');
            this_bank.mod.addMove("bank\t".concat(this_bank.mod.game.player, "\t").concat(this_bank.minForTrade[this_bank.selected_resource], "\t").concat(this_bank.selected_resource, "\t1\t").concat(desired_resource));
            this_bank.mod.endTurn();
            this_bank.overlay.close();
            this_bank.selected_resource = null;
            return;
          };
        });
      } else {
        document.querySelectorAll('.settlers-trade-resources').forEach(function (row) {
          row.classList.remove('selected');
          row.onclick = function (e) {
            var target = e.currentTarget;
            var disabled = target.classList.contains('settlers-row-disabled');
            if (!disabled) {
              this_bank.selected_resource = target.getAttribute('id');
              this_bank.render();
            }
          };
        });
      }
    }
  }]);
}();
module.exports = BankOverlay;